module.exports = __webpack_public_path__ + "img/media-img-12.80258570.png";